module.exports = __webpack_public_path__ + "static/media/icon-contacts.cfe30a22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-contacts.svg
// module id = 1220
// module chunks = 19